import React from 'react';
import { Cascader as AntdCascader } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './Cascader.css';

// Use React.ComponentProps to correctly extract Antd Cascader props
export type WxbCascaderProps = React.ComponentProps<typeof AntdCascader> & {
  label?: string;
  error?: string;
};

export const WxbCascader: React.FC<WxbCascaderProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下下拉就近渲染到触发器内;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdCascader
        {...(props as any)}
        id={controlId}
        className={`wxb-cascader ${error ? 'wxb-cascader-error' : ''} ${className}`}
        popupClassName="wxb-cascader-popup"
        getPopupContainer={getPopupContainer}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
